
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/job/[jobSlug]",
      function () {
        return require("private-next-pages/[locale]/job/[jobSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/job/[jobSlug]"])
      });
    }
  